export default __webpack_public_path__ + "static/media/vu-center-1.79288ed5.png";